import { useNavigate } from "react-router-dom";
import './HamMenuItem.scss';
import LanguageElementsHandler from "../../../repository/languageElementsHandler/LanguageElementsHandler";
import useMain from "../../../common/MainContext";

export default function HamMenuItem({ languageElements, itemId, isSelected, link }) {
    const { language } = useMain();
    const navigate = useNavigate();

    const languageElementsHandler = new LanguageElementsHandler(
        languageElements,
        language
    );

    function onMenuItemClicked() {
        navigate(link);
    }

    return (
        <div id={itemId} className={`hamMenuItem ${(isSelected) ? 'selected' : ''}`} onClick={onMenuItemClicked}>
            <div className='textArea'>
                <div className='title'>
                    <h4>{languageElementsHandler.get(`${itemId}-title`)}</h4>
                </div>
                <div className='descr'>
                    <h6>{languageElementsHandler.get(`${itemId}-descr`)}</h6>
                </div>
            </div>
        </div>
    )
}